(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.hideOnScrollDown = this.getAttribute('data-hide-on-scroll-down') !== 'false';
      this.ticking = false;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      // Keyboard access: focusing anything in a hidden header reveals it.
      this.onFocusIn = () => {
        if (this.header.classList.contains('is-hidden')) {
          this.header.classList.remove('is-hidden');
          this.reveal();
        }
      };
      this.addEventListener('focusin', this.onFocusIn);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.removeEventListener('focusin', this.onFocusIn);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    /* Elite scroll behavior: direction-aware with a 120px threshold, transform
       only, rAF-throttled passive listener; panels/focus pause the auto-hide.
       Emits both the new is-compact/is-hidden classes and Dawn's legacy classes
       so existing Dawn CSS/JS consumers keep working. */
    panelsOpen() {
      if ([...this.predictiveSearches].some((ps) => ps.isOpen)) return true;
      if (this.querySelector('.department-bar details[open]')) return true;
      if (this.querySelector('.search-scope__menu:not([hidden])')) return true;
      if (this.querySelector('[data-search-default]:not([hidden])')) return true;
      if (this.contains(document.activeElement) && document.activeElement !== document.body) return true;
      return false;
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const HIDE_THRESHOLD = 120;
        const goingDown = scrollTop > this.currentScrollTop;

        this.updateProgress(scrollTop);

        if (scrollTop <= Math.max(this.headerBounds.top || 0, 8)) {
          // Back at the top: full layout.
          this.header.classList.remove('scrolled-past-header', 'is-compact', 'is-hidden');
          document.body.classList.remove('header-compact');
          this.reset();
        } else if (scrollTop > HIDE_THRESHOLD) {
          this.header.classList.add('scrolled-past-header', 'is-compact');
          document.body.classList.add('header-compact');

          if (this.panelsOpen()) {
            // An open panel or focused control pauses auto-hide.
            this.header.classList.remove('is-hidden');
            this.reveal();
          } else if (goingDown && this.hideOnScrollDown && !this.preventHide && !this.headerIsAlwaysSticky) {
            this.header.classList.add('is-hidden');
            this.hide();
          } else if (!goingDown) {
            // Any scroll up reveals instantly in compact mode.
            if (!this.preventReveal) {
              this.header.classList.remove('is-hidden');
              this.reveal();
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              this.header.classList.add('is-hidden');
              this.hide();
            }
          }
        }

        this.currentScrollTop = scrollTop;
      });
    }

    updateProgress(scrollTop) {
      this.progressBar = this.progressBar !== undefined ? this.progressBar : this.querySelector('[data-scroll-progress]');
      if (!this.progressBar) return;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const ratio = max > 0 ? Math.min(1, scrollTop / max) : 0;
      this.progressBar.style.transform = `scaleX(${ratio})`;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
